<template>
    <img :src="randomImageURL" alt="图形验证码" title="点击切换验证码" @click="t=new Date().getTime()">
</template>
<script>
export default {
    data() {
            return {
                t: new Date().getTime()
            }
        },
        computed: {
            randomImageURL() {
                const connector = this.baseURL.indexOf('?') ? '&_t=' : '?_t='
                return `${this.baseURL}${connector}${this.t}`
            },
        },
        props: {
            baseURL: {
                type: String,
                required: true,
            }
        }
}
</script>
<style scoped>
img {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/Payment/components/components/randImg.vue